// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import estimateApi from '~/apis/estimate';
import {
  CHANGE_STATUS_ESTIMATE,
  CONVERT_TO_JOB,
  CREATE_ESTIMATE,
  DELETE_ESTIMATE,
  GET_ESTIMATE_DETAIL,
  GET_ESTIMATE_DETAIL_UPDATE,
  GET_ESTIMATE_SCHEDULE_LIST,
  GET_LIST_ESTIMATE,
  SEND_ESTIMATE,
  UPDATE_ESTIMATE,
} from '~/utils/constants/actionType';
import {
  IFormEstimate,
  IParamGetListEstimate,
  IParamsDetailEstimate,
  IPayloadChangeStatusEstimate,
  IPayloadDetailUpdateEstimate,
  IPayloadSendEstimate,
  IQueryUpdateEstimate,
} from '~/utils/interface/estimate';
import { IParamSchedule } from '~/utils/interface/schedule';

export const createEstimate = createAsyncThunk(
  CREATE_ESTIMATE,
  async (payload: IFormEstimate, { rejectWithValue }) => {
    try {
      const res = await estimateApi.createEstimate(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListEstimate = createAsyncThunk(
  GET_LIST_ESTIMATE,
  async (params: IParamGetListEstimate, { rejectWithValue }) => {
    try {
      const resp = await estimateApi.getListEstimate(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailEstimate = createAsyncThunk(
  GET_ESTIMATE_DETAIL,
  async (params: IParamsDetailEstimate, { rejectWithValue }) => {
    try {
      const resp = await estimateApi.getDetailEstimate(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateEstimate = createAsyncThunk(
  UPDATE_ESTIMATE,
  async (payload: IQueryUpdateEstimate, { rejectWithValue }) => {
    try {
      const resp = await estimateApi.updateEstimate(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEstimateScheduleList = createAsyncThunk(
  GET_ESTIMATE_SCHEDULE_LIST,
  async (params: IParamSchedule, { rejectWithValue }) => {
    try {
      const resp = await estimateApi.getScheduleList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEstimateDetailUpdate = createAsyncThunk(
  GET_ESTIMATE_DETAIL_UPDATE,
  async (payload: IPayloadDetailUpdateEstimate, { rejectWithValue }) => {
    try {
      const resp = await estimateApi.getEstimateDetailUpdate(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const convertToJob = createAsyncThunk(
  CONVERT_TO_JOB,
  async (estimateId: string, { rejectWithValue }) => {
    try {
      const resp = await estimateApi.convertToJob(estimateId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteEstimate = createAsyncThunk(
  DELETE_ESTIMATE,
  async (estimateId: string, { rejectWithValue }) => {
    try {
      const resp = await estimateApi.deleteEstimate(estimateId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendEstimate = createAsyncThunk(
  SEND_ESTIMATE,
  async (payload: IPayloadSendEstimate, { rejectWithValue }) => {
    try {
      const resp = await estimateApi.sendEstimate(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeStatusEstimate = createAsyncThunk(
  CHANGE_STATUS_ESTIMATE,
  async (payload: IPayloadChangeStatusEstimate, { rejectWithValue }) => {
    try {
      const resp = await estimateApi.changeStatus(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
